export default __webpack_public_path__ + "static/media/asymmetrical_airy.1c2f2c20.webp";